/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetFeatureLensRequest} from '@cash-web/protos/squareup/cash/semaphore/api/SemaphoreCustomerCircumstance.pb'
import {GetFeatureLensResponse} from '@cash-web/protos/squareup/cash/semaphore/api/SemaphoreCustomerCircumstance.pb'


export const getFeatureLens = (request: GetFeatureLensRequest, options?: CashRequestOptions) => post<GetFeatureLensRequest, GetFeatureLensResponse>("/2.0/cash/get-feature-lens", request, {...options, rejectOnError: true })